import React from 'react';
import ReactSlider, { ReactSliderProps } from 'react-slider';

const renderTrack: ReactSliderProps['renderTrack'] = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <div {...props} className="h-px mx-2.5 bg-white" />
);

const renderThumb: ReactSliderProps['renderThumb'] = (props, state) => {
  const { valueNow } = state;

  const formatValue = (value: number): string => {
    if (value === 0 || value === 1) {
      return value.toString();
    }

    return value.toFixed(2).slice(1);
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div {...props} className="absolute flex flex-col top-0.5">
      <svg
        width="4"
        height="3"
        viewBox="0 0 4 3"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
        className="self-center"
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M0 3L4 3L2 0L0 3Z" fill="white" />
      </svg>
      <button
        type="button"
        className="h-4 w-5 flex justify-center items-center rounded bg-white text-small"
      >
        {formatValue(valueNow)}
      </button>
    </div>
  );
};

type ComponentProps = {
  threshold: number[];
  handleChangeThreshold: (value: number[]) => void;
  handleSubmit: (value: number[]) => void;
  disabled?: boolean;
};

const RiskScoreSlider: React.FC<ComponentProps> = (props) => {
  const { threshold, handleChangeThreshold, handleSubmit, disabled = false } = props;

  const handleChange = (val: number[]): void => {
    handleChangeThreshold([val[0], val[1]]);
  };

  return (
    <div className="w-full -mt-px">
      {/* @ts-ignore */}
      <ReactSlider
        className="h-full w-full"
        renderTrack={renderTrack}
        renderThumb={renderThumb}
        minDistance={0.1}
        min={0}
        max={1}
        step={0.01}
        pearling
        value={threshold}
        onChange={handleChange}
        onAfterChange={handleSubmit}
        disabled={disabled}
      />
    </div>
  );
};

export default RiskScoreSlider;
